import { TCharacter, TChaser } from "../../data/character";
import { TGameState } from "../../data/gameContext"; // Adjust the import path as needed
import { GetRandomNumber } from "../../helper/common";
import { AreSameLocation as AreSameLocation } from "../map/mapGenerator";
import { nearestTowns } from "../map/townGenerator";

export function CheckAddChaser(updateState:TGameState, chaserAddHours: number): boolean
{
  if(!updateState.PlayerCharacter ) return false;

  //see if we should add another chaser - use the time elapsed since the last one
  if(updateState.GameTime - updateState.LastChaser <chaserAddHours) return false;
  
  //check they're not already all active
  if(!updateState.Chasers.find((x) => !x.Location)) return false;

  return true;
}


export function AddChaser(updateState:TGameState): TCharacter[]
{
  if(!updateState.PlayerCharacter ) return updateState.Chasers;

  //copy the current chasers
  let newChasers = structuredClone(updateState.Chasers);

  //get the next unassigned chaser
  let newChaser = newChasers.find((x:TChaser) => !x.Location);
  
  //put the new chaser at the starter town, unless the player is currently there, in whcih case use the first other town. 
  //Could use neareste towns so they start off at the next one...
  let town = updateState.GameTowns[updateState.StartingTownIndex];
  if(AreSameLocation(town.Location, updateState.PlayerCharacter.Location)) 
  {
    town = updateState.GameTowns[updateState.StartingTownIndex > 0 ? 0 : 1]; // Must have at least 2 towns.
  }
  newChaser!.Location = {...town.Location}; //we shouldn't have come here without at least one null chaser
  
  return newChasers;
}

//Move Chaser - pick a random town and move him there - he may stay at the same one, 
//or the player could avoid the chaser by going where he is (if he can see the chaser)
//should the chasers move to nearer towns?
export function MoveChasers(updateState:TGameState): TChaser[]
{
  let newChasers = updateState.Chasers.map((chaser: TChaser) => { 
    if(chaser.Location) 
    {    
      //find the nearest two or three towns (we know x & y cannot be null here, but the compiler doesn't seem to.)
      let sortedTowns = nearestTowns(chaser.Location, updateState.GameTowns);

      //TODO: prevent a loop - keep track of the last 10 towns visible. May need a chaser extension class, ratehr than putting everything in TCharacter.

      //Pick from the the three closest towns. Do we need an option to stay put? Exclude for now. Will be the first element if any.
      let townIndex = (sortedTowns[0].distance === 0 ? 1 : 0) + GetRandomNumber(3); 
      let town = sortedTowns[townIndex];

      return {...chaser, Location:{...town.Location}}
    }
    return chaser;
  }) 
  return newChasers;
}

//Remove chaser - this should set the last chaser to game time, or one may immediately pop back.

//Set whether chasers are visible. Generally false. True in debug mode, may be true if close to player, or player has special ability
export function SetChaserVisibility(updateState:TGameState, debugMode: boolean): TChaser[]
{
  let newChasers = updateState.Chasers.map((chaser: TChaser) => {
    let visible = debugMode && chaser.Location ? true : false
    return { ...chaser, IsVisible: visible}
  })

  return newChasers;
}